import {
  SearchMultipleSelection,
  type SearchMultipleSelectionProps,
  type OptionSelectionProps,
} from '@shared/components';
import { useMemo } from 'react';

export type BaseSearchSelectionProps = Pick<SearchMultipleSelectionProps, 'options' | 'label'> & {
  value: string[];
  onChange: (value: string[]) => void;
};

export default function BaseSearchSelection(props: Readonly<BaseSearchSelectionProps>) {
  const { value, onChange, options, label } = props;

  const selectedOptions = useMemo(
    () =>
      value
        .filter((val) => options.some((option) => option.value === val))
        .map((val) => options.find((option) => option.value === val)) as OptionSelectionProps[],
    [value, options],
  );

  return (
    <SearchMultipleSelection
      options={options}
      label={label}
      onChange={(_, value) => {
        onChange(value.map((val) => val.value as string));
      }}
      value={selectedOptions}
      sx={{ width: '100%', maxWidth: '276px' }}
      slotProps={{
        input: { placeholder: value.length === 0 ? 'แสดงทั้งหมด' : '' },
      }}
    />
  );
}
